import React from 'react';
import notFoundImage from '../assets/404.svg';

const NotFound = () => {
    return (
        <div>
            <center>
                <img src={notFoundImage} alt="Страница не найдена" style={{width: '300px', marginTop: '20px'}}/>
                <h1>404 - Страница не найдена</h1>
                <p>Извините, запрашиваемая страница не существует.</p>
            </center>
        </div>
    );
};

export default NotFound;